import React from 'react';
import { arrayOf, bool, func, object, string } from 'prop-types';
import clsx from 'clsx';
import {
    Grid,
    Table,
    TableHeaderRow,
    TableColumnVisibility
} from '@devexpress/dx-react-grid-material-ui';

import AddSensorPromptCell from './AddSensorPromptCell';
import NoDataCell from './NoDataCell';
import CellRenderer from './CellRenderer';
import MetaContext from './MetaContext';
import ProgressBar from '../ProgressBar';
import { getSensorName } from '../../helpers/sensors';

import defaultClasses from './SensorsTable.module.css';

const COLUMNS = [
    {
        name:  'sourceType',
        title: 'Source Type'
    },
    {
        getCellValue(row) {
            return getSensorName(row);
        },
        name:  'entityType',
        title: 'Entity Type'
    },
    {
        getCellValue(row) {
            return row.sensorTypeName;
        },
        name:  'type',
        title: 'Sensor Type'
    },
    {
        name:  'sourcing',
        title: 'Sensor Sourcing'
    },
    { name: 'action', title: 'Action' }
];

const StyledHeaderCellComponent = (props) => (
    <TableHeaderRow.Cell
        {...props}
        className={clsx(defaultClasses.cell, defaultClasses.headerCell)}
    />
);

const SensorsTable = ({
    disabled,
    error,
    isLoading,
    onNewSensor,
    onDeleteSensor,
    onSelectSensor,
    readOnly,
    sensors
}) => {
    const hiddenColumNames = [];
    let noDataMessage = (
        <AddSensorPromptCell
            disabled={readOnly}
            onNewSensor={onNewSensor}
        />
    );
    if (readOnly) {
        noDataMessage = 'This K2A rule does not have any sensors';
        hiddenColumNames.push('action');
    }

    return (
        <MetaContext.Provider value={{ onDeleteSensor, onSelectSensor }}>
            <ProgressBar
                className={defaultClasses.progressBar}
                hidden={!isLoading}
            />
            <Grid
                columns={COLUMNS}
                rows={sensors}
            >
                <Table
                    cellComponent={CellRenderer}
                    messages={{
                        noData: noDataMessage
                    }}
                    noDataCellComponent={NoDataCell}
                />
                <TableHeaderRow cellComponent={StyledHeaderCellComponent} />
                <TableColumnVisibility
                    key={hiddenColumNames}
                    defaultHiddenColumnNames={hiddenColumNames}
                />
            </Grid>
        </MetaContext.Provider>
    );
};

SensorsTable.defaultProps = {
    disabled:       false,
    isLoading:      false,
    onDeleteSensor: () => {},
    onNewSensor:    () => {},
    onSelectSensor: () => {},
    sensors:        []
};

SensorsTable.propTypes = {
    disabled:       bool,
    error:          string,
    isLoading:      bool,
    onDeleteSensor: func,
    onNewSensor:    func,
    onSelectSensor: func,
    sensors:        arrayOf(object)
};

export default SensorsTable;
